import React, { useContext, useEffect, useState } from "react";
import { DtrfForm } from "b2c6a1a8wq-ak/dist";
import Head from "next/head";
import { connect } from "react-redux";
import config from "../../config";
import { useHistory } from "react-router-dom";
import "./dtrf_css.css";
import HeaderContext from "../../context/HeaderContext";
const Dtrf_form = (props) => {
  const {setTitle} = useContext(HeaderContext);
  setTitle("Request/Order Test");
  const history = useHistory();
  const pushTo = (path) => {
    // console.log()
    history.push("/dtrfs");
  };
  const { currentDoctorDetails } = props;
  console.log("CurrentDoctorDetails", currentDoctorDetails);
  return (
    <>
      {
        currentDoctorDetails.apiState=="success"&&currentDoctorDetails.data.is_dtrf_activated=="Yes" ? 
        <>
          <Head>
            <script src="../../js/app.min.js"></script>
            <script src="bundles/prism/prism.js"></script>
            <script src="bundles/jquery-pwstrength/jquery.pwstrength.min.js"></script>
            <script src="bundles/bootstrap-daterangepicker/daterangepicker.js"></script>
            <script src="bundles/bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min.js"></script>
            <script src="bundles/bootstrap-timepicker/js/bootstrap-timepicker.min.js"></script>
            <script src="bundles/bootstrap-tagsinput/dist/bootstrap-tagsinput.min.js"></script>
            <link
              rel="stylesheet"
              href="bundles/select2/dist/css/select2.min.css"
            />
            <script src="bundles/select2/dist/js/select2.full.min.js"></script>
            <script src="bundles/jquery-selectric/jquery.selectric.min.js"></script>
            <script src="../../js/scripts.js"></script>
            <script src="../../js/custom.js"></script>
          </Head>
          {currentDoctorDetails.apiState == "success" ? (
            <DtrfForm
              fromDoctorDtrf={true}
              doctor_info={{
                doctorName:
                  currentDoctorDetails.apiState == "success"
                    ? {
                        _id: currentDoctorDetails.data._id,
                        fname: currentDoctorDetails.data.fname,
                        lname: currentDoctorDetails.data.lname,
                        nt_status_for_reporting:
                          currentDoctorDetails.data.nt_status_for_reporting,
                        value: currentDoctorDetails.data._id,
                      }
                    : {},
              }}
              institute_list={
                currentDoctorDetails.apiState == "success"
                  ? currentDoctorDetails.data.hospital
                  : []
              }
              url={config.dtrf}
              pushTo={pushTo}
            ></DtrfForm>
          ) : (
            <h2>Loading Dtrf form</h2>
          )}
        </>
        :
        <h6>Access Not Authorized</h6>
      }
    </>
  );
};
const mapStateToProps = (state) => ({
  currentDoctorDetails: state.getDoctorDetail,
});

export default connect(mapStateToProps)(Dtrf_form);
